import { defineStore } from 'pinia'

export const platformStore = defineStore({
  id: 'platform',
  state: () => ({
    // Empty array = no platform filter applied (backend treats an empty/absent
    // platform_ids list as "all platforms"). Real platform ids come from the
    // Platform table and are never "0", so that used to be a sentinel that
    // matched nothing and left new users looking at an empty stock list.
    platform: (localStorage.getItem('platform') !== null ? localStorage.getItem('platform') : JSON.stringify([])),
    platformList: [],
  }),
  actions: {
    setPlatform(args) {
      localStorage.setItem('platform', JSON.stringify(args));
      this.platform = JSON.stringify(args);
    },
    getPlatform() {
      return this.platform;
    },
    clear() {
      localStorage.setItem('platform', '[]');
      this.platform = '[]';
    },
    setPlatformList(args) {
      this.platformList = args;
    },
    getPlatformList(){
      return this.platformList;
    }
  }
})
